export default __webpack_public_path__ + "static/media/misc-fireplaceA-768w.fda1c6d0.png";